import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";

const useGetReviews = () => {
  const data = useQuery(api.professionalReviews.getReviews);
  const isLoading = data === undefined;
  return { data, isLoading };
};

export default useGetReviews;
